import React from 'react'
import { useLocation } from 'react-router-dom'

import OfferDetailsForm from '@/components-latest/ui/OfferPage/OfferDetailsForm'
import {
  useOfferFormNavigateBack,
  useOfferFormSuccessNavigate
} from '@/hooks/useOfferFormNavigateBack/useOfferFormNavigateBack'

const OfferDetailsFormWrapper: React.FC = () => {
  const location = useLocation()
  const state = location.state as {
    isEditing?: boolean
    offerId?: string
    initialDiscount?: number
    initialExpiration?: string
    name?: string
  }

  const navigateOnSuccess = useOfferFormSuccessNavigate('item_discount')

  const handleSuccess = () => {
    navigateOnSuccess(state?.offerId ? 'edit' : 'create')
  }

  const handleGoBack = useOfferFormNavigateBack('item_discount')

  return (
    <OfferDetailsForm
      onSuccess={handleSuccess}
      onGoBack={handleGoBack}
      offerId={state?.offerId}
      initialDiscount={state?.initialDiscount}
      initialExpiration={state?.initialExpiration}
      name={state?.name}
    />
  )
}
export default OfferDetailsFormWrapper
